export enum SiftDecisionType {
  APPROVED = 'Approved',
  REVIEW = 'Review',
  DECLINED = 'Declined',
}
